module.exports = __webpack_public_path__ + "media/img/frontend_application/video-icon-sm-61e0e2104215dfde1304c0de9417ddaf.png";